import React from "react";

export const PageBackground = ({ dim = 0.9 }) => (
  <div aria-hidden="true" data-testid="page-background" className="pointer-events-none fixed inset-0 -z-10">
    <img src="/hero-celestial.jpg" alt="" className="w-full h-full object-cover" />
    <div className="absolute inset-0" style={{ background: `rgba(5,8,18,${dim})` }} />
  </div>
);
